// extracted by mini-css-extract-plugin
export default {"collectionProducts__listProducts":"ListProducts_collectionProducts__listProducts__VIouB"};